/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
const MESSAGES = {
  SELECT_CUSTOMER: "Select a customer",
  NO_CUSTOMER_FOUND: "No customer found",
  NO_CUSTOMER_SELECTED: "No customer selected",
  DELETE_CUSTOMER_TITLE: "Are you sure you want to delete the customer ",
};

const TITLES = {
  EDIT: "Edit",
  DELETE: "Delete",
  CANCEL: "Cancel",
  CUSTOMERS: "Customers",
  CUSTOMER: "Customer",
  ADD_CUSTOMER: "Add Customer",
  SEARCH_CUSTOMER: "Search Customer",
  DELETE_CUSTOMER: "Delete Customer",
  DELETE_CUSTOMER_CONFIRMATION: "Delete Customer?",
};

export { MESSAGES, TITLES };
